module.exports = __webpack_public_path__ + "static/img/gxbwz.b5ec87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gxbwz.png
// module id = rsz/
// module chunks = 1